<!-- Title -->
<app-title class="d-none d-lg-block" />

<!-- Content -->
<main>
  <router-outlet />
</main>

<!-- Footer -->
<footer>
  <app-footer />
</footer>